module.exports = __webpack_public_path__ + "img/list6_bg5.30baef34.png";